import { faQuestionCircle, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";

interface ImportantMessageBannerProps {
    icon?: IconDefinition
    message: string;
    title: string;
}

const ImportantMessageBanner: FC<ImportantMessageBannerProps> = ({ icon = faQuestionCircle, message, title}) => {
    return <span className={` text-sm text-gray-800`} id='keyWarningId'>
        <FontAwesomeIcon style={{ color: 'rgb(1 84 240 / var(--tw-text-opacity, 1))', height: '1rem', paddingTop: '0.5rem', paddingRight: '0.5rem' }} className='faIcon' icon={icon} />
        {<><b>{title}</b> {message}</>}
    </span>
}

export default ImportantMessageBanner;